"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
export function useFaqAccordion(t0) {
  const $ = _c(3);
  const defaultOpen = t0 === undefined ? 0 : t0;
  const [openIndex, setOpenIndex] = useState(defaultOpen);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = index => setOpenIndex(prev => prev === index ? -1 : index);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggle = t1;
  let t2;
  if ($[1] !== openIndex) {
    t2 = {
      openIndex,
      toggle
    };
    $[1] = openIndex;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}